/**
 * Toast 通知系统
 */

export function showToast(message, type) {
    type = type || 'success';
    const container = document.getElementById('toastContainer');
    if (!container) return;

    const existing = container.querySelector('.toast:last-child');
    if (existing && existing.textContent === message) {
        clearTimeout(existing._dismissTimer);
        clearTimeout(existing._removeTimer);
        existing._dismissTimer = setTimeout(function () {
            existing.classList.remove('show');
            existing._removeTimer = setTimeout(function () { existing.remove(); }, 300);
        }, 2500);
        return;
    }

    const toast = document.createElement('div');
    toast.className = 'toast toast-' + type;
    toast.textContent = message;
    container.appendChild(toast);

    requestAnimationFrame(function () {
        toast.classList.add('show');
    });

    toast._dismissTimer = setTimeout(function () {
        toast.classList.remove('show');
        toast._removeTimer = setTimeout(function () { toast.remove(); }, 300);
    }, 2500);
}

export function showUndoToast(message, undoCallback, duration) {
    duration = duration || 8000;
    const container = document.getElementById('toastContainer');
    if (!container) return;

    const toast = document.createElement('div');
    toast.className = 'toast toast-warning toast--undo';

    const msgSpan = document.createElement('span');
    msgSpan.textContent = message;
    toast.appendChild(msgSpan);

    const undoBtn = document.createElement('button');
    undoBtn.textContent = '↩ 撤销';
    undoBtn.className = 'toast-undo-btn';
    undoBtn.onclick = function() {
        clearTimeout(toast._dismissTimer);
        clearTimeout(toast._removeTimer);
        toast.remove();
        if (undoCallback) undoCallback();
    };
    toast.appendChild(undoBtn);

    container.appendChild(toast);

    requestAnimationFrame(function () {
        toast.classList.add('show');
    });

    toast._dismissTimer = setTimeout(function () {
        toast.classList.remove('show');
        toast._removeTimer = setTimeout(function () { toast.remove(); }, 300);
    }, duration);
}
